import React from 'react';

const About = () => {
  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',lineHeight:'12'}}>
      <h1>About Page</h1>
    </div>
  );
};

export default About;
